<template>
  <div>
    <el-row>
      <el-tree
        :data="data"
        show-checkbox
        node-key="id"
        :props="defaultProps"
        :default-checked-keys="settings"
        default-expand-all
        @check="handleCheckedFieldsChange"
        ref="tree"
      ></el-tree>
    </el-row>
  </div>
</template>
<script>
  export default {
    props: {
      data: Array,
      defaultProps: Object,
      settings: Array,
    },
    methods: {
      handleCheckedFieldsChange() {
        const checkedNodes = this.$refs.tree.getCheckedNodes(true);
        this.$emit('handle-settings', checkedNodes);
      },
    },
  };
</script>
<style></style>
